export const buildProvenance = { "commitHash": "f4be7ab0bf29f0b1e339ac8beaae3b349f2f7364", "branchName": "refs/heads/release/2025.4", "buildDate": "2026-04-01T17:39:46.182Z", "version": "2025.4.10533" };
